import "core-js/modules/es.array.join.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "table"
  }, [_vm.type === 1 ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "用户订单号",
      prop: "$id",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$id,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$id", $$v);
            },
            expression: "scope.row.$id"
          }
        })];
      }
    }], null, false, 1467860548)
  }), _c("el-table-column", {
    attrs: {
      prop: "form",
      width: "150",
      label: "寄件公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.form,
            callback: function callback($$v) {
              _vm.$set(scope.row, "form", $$v);
            },
            expression: "scope.row.form"
          }
        })];
      }
    }], null, false, 2165759355)
  }), _c("el-table-column", {
    attrs: {
      prop: "sender",
      width: "120",
      label: "寄件人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.sender,
            callback: function callback($$v) {
              _vm.$set(scope.row, "sender", $$v);
            },
            expression: "scope.row.sender"
          }
        })];
      }
    }], null, false, 1249472742)
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      width: "140",
      label: "寄件电话"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.phone,
            callback: function callback($$v) {
              _vm.$set(scope.row, "phone", $$v);
            },
            expression: "scope.row.phone"
          }
        })];
      }
    }], null, false, 853552305)
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      width: "180",
      label: "寄件详细地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.address,
            callback: function callback($$v) {
              _vm.$set(scope.row, "address", $$v);
            },
            expression: "scope.row.address"
          }
        })];
      }
    }], null, false, 4177072347)
  }), _c("el-table-column", {
    attrs: {
      prop: "c03CusName",
      label: "收件公司",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c03CusName,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c03CusName", $$v);
            },
            expression: "scope.row.c03CusName"
          }
        })];
      }
    }], null, false, 4271735535)
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjStaff",
      label: "收件人",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjStaff,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjStaff", $$v);
            },
            expression: "scope.row.c02ObjStaff"
          }
        })];
      }
    }], null, false, 1489185677)
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjMobile",
      label: "收件电话",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjMobile,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjMobile", $$v);
            },
            expression: "scope.row.c02ObjMobile"
          }
        })];
      }
    }], null, false, 1718670187)
  }), _c("el-table-column", {
    attrs: {
      prop: "$phone",
      width: "140",
      label: "收件手机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$phone,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$phone", $$v);
            },
            expression: "scope.row.$phone"
          }
        })];
      }
    }], null, false, 2207882229)
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjAddress",
      label: "收件详细地址",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjAddress,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjAddress", $$v);
            },
            expression: "scope.row.c02ObjAddress"
          }
        })];
      }
    }], null, false, 801320381)
  }), _c("el-table-column", {
    attrs: {
      prop: "$fileType",
      label: "托寄物内容",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$fileType,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$fileType", $$v);
            },
            expression: "scope.row.$fileType"
          }
        })];
      }
    }], null, false, 3269987159)
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjAddress",
      label: "托寄物数量",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(Array.isArray(scope.row._codes) ? scope.row._codes.length : "") + " ")];
      }
    }], null, false, 2711042847)
  }), _c("el-table-column", {
    attrs: {
      prop: "$zhongliang",
      label: "包裹重量",
      width: "75"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$zhongliang,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$zhongliang", $$v);
            },
            expression: "scope.row.$zhongliang"
          }
        })];
      }
    }], null, false, 2123400912)
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjAddress",
      label: "寄方备注",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(Array.isArray(scope.row._codes) ? scope.row._codes.join(",") : "") + " ")];
      }
    }], null, false, 3237796812)
  }), _c("el-table-column", {
    attrs: {
      prop: "payType",
      width: "100",
      label: "运费付款方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.payType,
            callback: function callback($$v) {
              _vm.$set(scope.row, "payType", $$v);
            },
            expression: "scope.row.payType"
          }
        })];
      }
    }], null, false, 1853390333)
  }), _c("el-table-column", {
    attrs: {
      prop: "type",
      width: "100",
      label: "业务类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.type,
            callback: function callback($$v) {
              _vm.$set(scope.row, "type", $$v);
            },
            expression: "scope.row.type"
          }
        })];
      }
    }], null, false, 1457046773)
  }), _c("el-table-column", {
    attrs: {
      prop: "ssss",
      width: "88",
      label: "件数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.type,
            callback: function callback($$v) {
              _vm.$set(scope.row, "type", $$v);
            },
            expression: "scope.row.type"
          }
        })];
      }
    }], null, false, 1457046773)
  }), _c("el-table-column", {
    attrs: {
      prop: "_Num",
      width: "150",
      label: "月结卡号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row._Num,
            callback: function callback($$v) {
              _vm.$set(scope.row, "_Num", $$v);
            },
            expression: "scope.row._Num"
          }
        })];
      }
    }], null, false, 2692496612)
  }), _c("el-table-column", {
    attrs: {
      prop: "_COde",
      width: "150",
      label: "组织编码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row._COde,
            callback: function callback($$v) {
              _vm.$set(scope.row, "_COde", $$v);
            },
            expression: "scope.row._COde"
          }
        })];
      }
    }], null, false, 2448247999)
  })], 1) : _vm.type === 2 ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      size: "mini"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "",
      width: "120",
      prop: "$id"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "$id",
      width: "95",
      label: "客户订单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$id,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$id", $$v);
            },
            expression: "scope.row.$id"
          }
        })];
      }
    }])
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data1",
      label: "收方信息",
      width: "1000"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "c02ObjStaff",
      label: "*收件人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjStaff,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjStaff", $$v);
            },
            expression: "scope.row.c02ObjStaff"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjMobile",
      label: "*收件人手机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjMobile,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjMobile", $$v);
            },
            expression: "scope.row.c02ObjMobile"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$phone",
      label: "收件人电话"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$phone,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$phone", $$v);
            },
            expression: "scope.row.$phone"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c03CusName",
      label: "收件公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c03CusName,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c03CusName", $$v);
            },
            expression: "scope.row.c03CusName"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$p",
      label: "收件人地址-省"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$p,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$p", $$v);
            },
            expression: "scope.row.$p"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$c",
      label: "收件人地址-市"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$c,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$c", $$v);
            },
            expression: "scope.row.$c"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$t",
      label: "收件人地址-区"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$t,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$t", $$v);
            },
            expression: "scope.row.$t"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ObjAddress",
      label: "*收件人详细地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.c02ObjAddress,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02ObjAddress", $$v);
            },
            expression: "scope.row.c02ObjAddress"
          }
        })];
      }
    }])
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data4",
      label: "寄方信息",
      width: "1000"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "sender",
      label: "*寄件人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.sender,
            callback: function callback($$v) {
              _vm.$set(scope.row, "sender", $$v);
            },
            expression: "scope.row.sender"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "*寄件人手机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.phone,
            callback: function callback($$v) {
              _vm.$set(scope.row, "phone", $$v);
            },
            expression: "scope.row.phone"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "_tel",
      label: "寄件人电话"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row._tel,
            callback: function callback($$v) {
              _vm.$set(scope.row, "_tel", $$v);
            },
            expression: "scope.row._tel"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "form",
      label: "寄件公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.form,
            callback: function callback($$v) {
              _vm.$set(scope.row, "form", $$v);
            },
            expression: "scope.row.form"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$p2",
      label: "寄件人地址-省"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$p2,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$p2", $$v);
            },
            expression: "scope.row.$p2"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$c2",
      label: "寄件人地址-市"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$c2,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$c2", $$v);
            },
            expression: "scope.row.$c2"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$t2",
      label: "寄件人地址-区"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$t2,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$t2", $$v);
            },
            expression: "scope.row.$t2"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "*寄件人详细地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.address,
            callback: function callback($$v) {
              _vm.$set(scope.row, "address", $$v);
            },
            expression: "scope.row.address"
          }
        })];
      }
    }])
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data2",
      label: "货物信息",
      width: "1000"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "$tuojiwu",
      label: "*托寄物"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$tuojiwu,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$tuojiwu", $$v);
            },
            expression: "scope.row.$tuojiwu"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$tuojiwushuliang",
      label: "托寄物数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$tuojiwushuliang,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$tuojiwushuliang", $$v);
            },
            expression: "scope.row.$tuojiwushuliang"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$baonangshu",
      label: "包裹总数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$baonangshu,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$baonangshu", $$v);
            },
            expression: "scope.row.$baonangshu"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$zhongliang",
      label: "包裹总重量（KG）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$zhongliang,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$zhongliang", $$v);
            },
            expression: "scope.row.$zhongliang"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$chang",
      label: "长（cm"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "$huan",
      label: "宽（cm）"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "$gao",
      label: "高（cm）"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data3",
      width: "1000",
      label: "物流产品信息"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "$express",
      label: "*物流产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$express,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$express", $$v);
            },
            expression: "scope.row.$express"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "payType",
      label: "*物流付款方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.payType,
            callback: function callback($$v) {
              _vm.$set(scope.row, "payType", $$v);
            },
            expression: "scope.row.payType"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "_Num",
      label: "月结卡号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row._Num,
            callback: function callback($$v) {
              _vm.$set(scope.row, "_Num", $$v);
            },
            expression: "scope.row._Num"
          }
        })];
      }
    }])
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data6",
      width: "1000",
      label: "揽收&派送"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "是否通知揽件",
      label: "是否通知揽件"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "预约揽收日期",
      label: "预约揽收日期"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "预约揽收时间",
      label: "预约揽收时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "定时派送类型",
      label: "定时派送类型"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "派送指定日期",
      label: "派送指定日期"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "派送指定时段",
      label: "派送指定时段"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "自取",
      label: "自取"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data7",
      width: "1000",
      label: "代收货款"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "代收金额",
      label: "代收金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "代收卡号",
      label: "代收卡号"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data8",
      width: "1000",
      label: "保价服务"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "保价金额",
      label: "保价金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "定额保-保价档位",
      label: "定额保-保价档位"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data9",
      width: "1000",
      label: "纸质回单"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "纸质回单-签名",
      label: "纸质回单-签名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "纸质回单-盖章",
      label: "纸质回单-盖章"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "纸质回单-登记身份证",
      label: "纸质回单-登记身份证"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "纸质回单-身份证复印件",
      label: "纸质回单-身份证复印件"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "回单份数",
      label: "回单份数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "回单备注",
      label: "回单备注"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "是否签返第三方",
      label: "是否签返第三方"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方收件人",
      label: "第三方收件人"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方公司",
      label: "第三方公司"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方手机",
      label: "第三方手机"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方电话",
      label: "第三方电话"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方省",
      label: "第三方省"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方市",
      label: "第三方市"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方区",
      label: "第三方区"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "第三方详细地址",
      label: "第三方详细地址"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data10",
      width: "1000",
      label: "拍照回传"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "拍照回传",
      label: "拍照回传"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "拍照张数",
      label: "拍照张数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "拍照备注",
      label: "拍照备注"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data11",
      width: "1000",
      label: "电子回单"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "文件ID",
      label: "文件ID"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "待签署文件名",
      label: "待签署文件名"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data12",
      width: "1000",
      label: "包装服务"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "包材编码",
      label: "包材编码"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "包装服务费",
      label: "包装服务费"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data13",
      width: "1000",
      label: "超长超重"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "超长超重服务费",
      label: "超长超重服务费"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data14",
      width: "1000",
      label: "保鲜服务"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "保鲜服务",
      label: "保鲜服务"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data15",
      width: "1000",
      label: "密钥认证"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "密钥认证",
      label: "密钥认证"
    }
  })], 1), _c("el-table-column", {
    attrs: {
      prop: "data5",
      width: "1000",
      label: "备注&补充信息"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "_codes",
      label: "订单备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row._codes ? scope.row._codes.join(",") : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$ext1",
      label: "扩展字段1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$ext1,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$ext1", $$v);
            },
            expression: "scope.row.$ext1"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$ext2",
      label: "扩展字段2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$ext2,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$ext2", $$v);
            },
            expression: "scope.row.$ext2"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "$ext3",
      label: "扩展字段3"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: ""
          },
          model: {
            value: scope.row.$ext3,
            callback: function callback($$v) {
              _vm.$set(scope.row, "$ext3", $$v);
            },
            expression: "scope.row.$ext3"
          }
        })];
      }
    }])
  })], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_vm.isHX && (_vm.isSender || _vm.isCpscAdmin || _vm.isAdmin) ? _c("el-button", {
    attrs: {
      type: "success",
      loading: _vm.loading,
      size: "mini"
    },
    on: {
      click: _vm.toSendViaSf
    }
  }, [_vm._v("聚合下单")]) : _vm._e(), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("导出")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])], 1), _vm.orderMessage.succeeded.length ? _c("el-alert", {
    attrs: {
      title: "成功的订单号",
      type: "success",
      description: _vm.orderMessage.succeeded.join(","),
      "show-icon": ""
    }
  }) : _vm._e(), _vm.orderMessage.failed.length ? _c("el-alert", {
    attrs: {
      title: "失败的订单号",
      type: "error",
      description: _vm.orderMessage.failed.join(","),
      "show-icon": ""
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };